// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-nav {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1;
}
.main-nav li a {
  cursor: help;
  padding: 10px 16px;
  border-radius: 4px;
}
.main-nav li .fa {
  margin-right: 10px;
}
.main-nav li.link-active a,
.main-nav li.link-active a:hover,
.main-nav li.link-active a:focus {
  background-color: #4189C7;
  color: white;
}
@media (min-width: 768px) {
  .main-nav {
    width: calc(25% - 30px);
    min-width: 180px;
  }
  .main-nav .navbar {
    border-radius: 0 15px 15px 0;
    border-width: 0px;
    height: 100%;
  }
  .main-nav .navbar a {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .main-nav .navbar ul {
    float: none;
  }
  .main-nav .navbar li {
    float: none;
    font-size: 15px;
    margin: 6px;
  }
  .main-nav .navbar li a {
    padding: 10px 16px;
    border-radius: 4px;
  }
  .main-nav .navbar-header {
    float: none;
  }
  .main-nav .navbar-collapse {
    padding: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/nav-menu/nav-menu.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE;IACE,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,eAAe;IACf,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".main-nav {\r\n  position: fixed;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 1;\r\n}\r\n.main-nav li a {\r\n  cursor: help;\r\n  padding: 10px 16px;\r\n  border-radius: 4px;\r\n}\r\n.main-nav li .fa {\r\n  margin-right: 10px;\r\n}\r\n.main-nav li.link-active a,\r\n.main-nav li.link-active a:hover,\r\n.main-nav li.link-active a:focus {\r\n  background-color: #4189C7;\r\n  color: white;\r\n}\r\n@media (min-width: 768px) {\r\n  .main-nav {\r\n    width: calc(25% - 30px);\r\n    min-width: 180px;\r\n  }\r\n  .main-nav .navbar {\r\n    border-radius: 0 15px 15px 0;\r\n    border-width: 0px;\r\n    height: 100%;\r\n  }\r\n  .main-nav .navbar a {\r\n    width: 100%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .main-nav .navbar ul {\r\n    float: none;\r\n  }\r\n  .main-nav .navbar li {\r\n    float: none;\r\n    font-size: 15px;\r\n    margin: 6px;\r\n  }\r\n  .main-nav .navbar li a {\r\n    padding: 10px 16px;\r\n    border-radius: 4px;\r\n  }\r\n  .main-nav .navbar-header {\r\n    float: none;\r\n  }\r\n  .main-nav .navbar-collapse {\r\n    padding: 0px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
